import { render, staticRenderFns } from "./MendingPointsHeader.vue?vue&type=template&id=277862d6&scoped=true&"
import script from "./MendingPointsHeader.vue?vue&type=script&lang=js&"
export * from "./MendingPointsHeader.vue?vue&type=script&lang=js&"
import style0 from "./MendingPointsHeader.vue?vue&type=style&index=0&id=277862d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277862d6",
  null
  
)

export default component.exports